import React, {Component} from 'react';

import SpecialPricingForm from '../../../shared/components/SpecialPricingForm';

class CampaignSpecialPricing extends Component {
  constructor(){
    super();

    this.state = {
      updating:false,
      loading:true
    };
  }

  componentWillMount(){
    this.props.loadCampaign(this.props.campaignId)
      .then(() => Promise.all([
        this.props.loadAgency(this.props.agencyId),
        this.props.loadBrand(this.props.brandId)
      ]))
      .then(() => this.setState({loading:false}))
  }

  handleSubmit(data){
    this.setState({updating:true});

    if(data.useCostPerCompletion){
      this.props.updateCampaign(this.props.campaignId,{
        useCostPerCompletion:true,
        revenueSplit:data.revenueSplit,
        costPerCompletion:data.defaultCostPerCompletion
      })
        .then(() => this.setState({updating:false}))
        .catch((err) => this.setState({error:err}));
      
    } else {
      console.log('UPDATE WITH ',data);
      this.props.updateCampaign(this.props.campaignId,{
        useCostPerCompletion:false,
        chooseCost:data.chooseDefaultCost,
        revenueSplit:data.revenueSplit,
        ratableCost:data.ratableDefaultCost,
        thisOrThatCost:data.thisOrThatDefaultCost,
        qaCost:data.qaDefaultCost
      })
        .then(() => this.setState({updating:false}))
        .catch(() => this.setState({updating:false}));
        
    }
  }

  render(){
    const {
      defaultRevenueSplit,
      defaultDefaultRevenueSplit,
      chooseDefaultCost,
      defaultChooseDefaultCost,
      thisOrThatDefaultCost,
      defaultThisOrThatDefaultCost,
      ratableDefaultCost,
      defaultRatableDefaultCost,
      qaDefaultCost,
      defaultQADefaultCost,
      isEditable,
      costPerCompletion,
      useCostPerCompletion
    } = this.props;

    const { updating } = this.state;

    return (
      <div>
        <SpecialPricingForm
          forceUpdate
          updateButtonText={updating ? 'Updating experience':'Update Experience'}
          readOnlyMessage='Can only edit experience drafts'
          defaultRevenueSplit={defaultRevenueSplit}
          defaultDefaultRevenueSplit={defaultDefaultRevenueSplit}
          chooseDefaultCost={chooseDefaultCost}
          defaultChooseDefaultCost={defaultChooseDefaultCost}
          thisOrThatDefaultCost={thisOrThatDefaultCost}
          defaultThisOrThatDefaultCost={defaultThisOrThatDefaultCost}
          ratableDefaultCost={ratableDefaultCost}
          defaultRatableDefaultCost={defaultRatableDefaultCost}
          qaDefaultCost={qaDefaultCost}
          defaultQADefaultCost={defaultQADefaultCost}
          defaultCostPerCompletion={costPerCompletion}
          useCostPerCompletion={useCostPerCompletion}
          onSubmit={(data) => this.handleSubmit(data)}
          readOnly={!isEditable}
        />
        <br />
        <br />
      </div>
    )
  }
}

export default CampaignSpecialPricing;



// WEBPACK FOOTER //
// ./src/routes/CampaignSpecialPricing/components/CampaignSpecialPricing.js